import { render, staticRenderFns } from "./AmazeSnackbar.vue?vue&type=template&id=aa130078"
import script from "./AmazeSnackbar.vue?vue&type=script&lang=js"
export * from "./AmazeSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports